import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Automationtwo = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://vfgzyrwzcc.execute-api.us-east-1.amazonaws.com/all-data", {
                    method: 'GET',
                    headers: {
                        'x-api-key': '154122054',  // Pass your API key here
                    }
                });
    
                const data = await response.json();
    
                // Filter data based on category and subcategory
                const filteredData = data.filter(product => 
                    product.category === "AKT Division" && product.subcategory === "Automotive Sheet Metal"
                );

                // Check if filteredData is an array before updating the state
                if (Array.isArray(filteredData)) {
                    setProducts(filteredData);
                } else {
                    console.error("Filtered data is not an array:", filteredData);
                    setProducts([]); // Set an empty array if data is not an array
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
                setProducts([]); // Set an empty array on error
            }
        };
    
        fetchData();
    }, []); // Empty dependency array ensures this runs once after the component mounts

    if (loading) {
        return <div className="text-white text-center justify-center font-extrabold mt-44">Loading...</div>; // Show loading text until data is fetched
    }

    if (!Array.isArray(products)) {
        // If products is still not an array, show an error message
        return <div>Error: Products data is not an array or there was an issue with fetching.</div>;
    }

    return (
        <div className="w-full mx-auto py-4 sm:px-0 md:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {products.map((product, index) => (
                    <Box
                        key={index}
                        image={product.imageUrl}  // Assuming the API returns a URL for the image
                        title={product.title}
                        items={product.descriptions || []} // Fallback to empty array if no descriptions
                        // link={`/products/${product.productId}`} 
                    />
                ))}
            </div>
        </div>
    );
};

const Box = ({ image, title, items }) => {
    const [bgColor, setBgColor] = useState("transparent");

    return (
        <div className="flex flex-col bg-white rounded-lg overflow-hidden p-4 duration-300 ease-in-out">
            {/* Image Container with Zoom Effect */}
            <div className="w-full h-[260px] overflow-hidden rounded-md">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover rounded-md transform transition duration-300 hover:scale-110"
                />
            </div>
            <div className="flex-grow">
                <h2 className="text-2xl md:text-3xl font-semibold mt-4 h-[60px] overflow-hidden">
                    {title}
                </h2>
                <ul className="text-gray-600 mt-2 text-base md:text-lg space-y-2 list-none">
                    {items.map((item, index) => (
                        <li key={index} className="flex items-center">
                            <span className="mr-3 text-xl md:text-2xl leading-none">•</span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
            <Link to="#">
                <button
                    className="px-3 py-1 w-full mt-9 border-2 border-[#0C2340] text-[#0C2340] hover:text-white font-semibold rounded-lg transition duration-300"
                    style={{ backgroundColor: bgColor }}
                    onMouseEnter={() => setBgColor("#1B365D")}
                    onMouseLeave={() => setBgColor("white")}
                >
                    VIEW ALL
                </button>
            </Link>
        </div>
    );
};

export default Automationtwo;
